import { AfterContentInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DirectDebitService } from './services/direct-debit.service';

@Component({
    selector: 'app-direct-debit',
    templateUrl: './direct-debit.component.html',
    styleUrls: ['./direct-debit.component.scss']
})
export class DirectDebitComponent implements OnInit, AfterContentInit, OnDestroy {
    loader = false;
    subs: Subscription[] = [];
    constructor(private directDbtSrv: DirectDebitService) {}
    ngOnDestroy(): void {
        this.subs.forEach((c) => c.unsubscribe());
    }
    ngAfterContentInit(): void {
        this.directDbtSrv.loaderStatus.subscribe((status) => (this.loader = status));
    }

    ngOnInit(): void {}
}
